/**
 * Calculate the anchor edges to use in placing the popover.
 */
import { Edge } from "./getPosition"
import getAutoPosition from "./getAutoPosition"
import getBoundingOffsets from "./getBoundingOffsets"
import getPreference, { Preference } from "./getPreference"

type Offsets = ReturnType<typeof getBoundingOffsets>

const getEdges = (
  preference: Preference,
  elementRect: ClientRect,
  offsets: Offsets
) => {
  const [, secondary] = getPreference(preference)
  const primaryEdge = getAutoPosition(elementRect, offsets)
  const edges: [Edge, Edge] = [primaryEdge, secondary ?? primaryEdge]

  return edges
}

export default getEdges
